module.exports = __webpack_public_path__ + "img/onlineService-black.630d45cd.png";